import { Injectable } from '@angular/core';
import { BaseApi } from '../../laas/base-api.service';
import { map } from 'rxjs/operators';

@Injectable()
export class AddCustomerService {

  constructor(
    private api: BaseApi,
  ) { }

  addCustomer(admin) {
    return this.api.postRes(`/users/register`, admin).pipe(map(res => {
      return res;
    }))
  }

  getCoAppCount(custId){
    return this.api.postRes('/users/getCoAppCount',{custId : custId}).pipe(map( resp => {
      console.log("resp in service " +  JSON.stringify(resp));
      return resp;
    }))
  }

  getAppCount(){
    return this.api.postRes('/users/getAppCount',"").pipe(map( resp => {
      console.log("resp in service " +  JSON.stringify(resp));
      return resp;
    }))
  }

  getGuarantorCount(custId){
    return this.api.postRes('/users/getGuarantorCount',{custId : custId}).pipe(map( resp => {
      console.log("resp in service " +  JSON.stringify(resp));
      return resp;
    }))
  }



}
